export const language = {
    english: {
        landingPage:
        {
            welcomeMessage: "Welcome to your new digital support service!",
            helpMessage: "How can we help",
            supportText: "Troubleshooting",
            productInfoText: "Product Information",
            trainingText: "Training & Maintenance Videos",
            accountInfo: "Account Information",
            termsAndCondition: "Terms and Conditions",
            change: "Change",
            dishmachineModelType: "Change dishmachine model",
            downloadMessage: 'Want to manage your dishmachine on the go?',
            download: 'Download',
            deviceInfo: 'with your',
        },
        trainingPage: {
            header: "Operator Training for the ES-2000",
            maintenanceText: "Daily Maintenance",
            troubleshooting: "Troubleshooting",
            prepareText: "How to prepare your wares for wash",
            startOver: "Restart"
        },
        esrSupport: {
            header: "Is this information correct?",
            modelLabel: "Dishmachine Model",
            accountLabel: "Customer Name",
            stateLabel: "State",
            zipLabel: "Zip",
            updateButton: "No, needs updating",
            clearAll: "Clear All",
            startChat: "Start Chat",
            contactEcolab: "Call Ecolab",
            closeButton: "Close",
            confirmButton: "Yes, this is correct",
            backLabel: "Back",
            startOver: "Restart",
            term1: "by tapping “Call Ecolab” I hereby agree to receive text",
            term2: "messages from Ecolab related to this issue",
            term3: "by tapping “Start Chat” I hereby agree to receive text",
            change: "Change"

        },
        esrEdit: {
            header: "We need a few details about your business in order to find your account",
            typeLabel: "Dishmachine Type",
            modelLabel: "Dishmachine Model",
            optionalLabel: "(optional)",
            buisnessLabel: "Name Of Business",
            addressLabel: "Address",
            cityLabel: "City",
            stateLabel: "State",
            zipLabel: "Zip",
            continueButton: "Continue",
            addressError: "Address is required.",
            cityError: "City is required."
        },
        esrSupportDetails: {
            header: "If none of these steps fixed the issue, please submit a service request and describe the issue.",
            nameLabel: "On-Site Contact Name",
            phoneLabel: "On-Site Contact Phone #",
            noteLabel: "I agree to receive texts from Ecolab related to this issue",
            detailLabel: "Additional Details (optional)",
            directionLabel: "Do not include sensitive information like billing information, credit card numbers, etc",
            uploadButton: "Upload a Photo",
            submitButton: "Submit",
            summaryButton: "Summary",
            feildError: "Error submitting request, please double-check the fields for issues.",
            nameError: "Name is required.",
            phoneError: "Phone number is required."
        },
        esrSummary: {
            header: "Request Status",
            requsetLabel: "Request",
            detailsLabel: "View Details",
            summaryText: "Issue submitted. Our team has received your request and will provide updates here as service is completed. You can refer to this page via the link that was texted to the phone number provided.",
            infoText: "Service requests will be processed between 8am - 4:30pm CT Monday - Friday. If you need immediate assistance, call",
            closeButton: "Close Request",
            commentButton: "Add Comment"
        },
        troubleShooting: {
            header: "What's going on?",
            startLabel: "Restart",
            backLabel: "Back",
            trouble: "Troubleshooting",
            label: "Let’s get your machine fixed!",
            estimation: "Estimated Time: 5 - 10 min",
            desc: "Follow these steps to troubleshoot your issue. If the problem isn’t resolved, we’ll help you submit a support ticket.",
            poorResults: 'Poor Results',
            machineIssue: 'Machine Issue',
            next: 'Next',
            start: 'Start'
        },
        steps: {
            header: "Select an issue",
            startLabel: "Restart",
            backLabel: "Back",
            helpButton: "Request Help",
            fixLabel: "Let’s get your machine fixed!",
            infoText: "We'll show you a few quick troubleshooting steps you can try.",
            stepMessage: "If these don't work, you can submit a service request after viewing the troubleshooting steps.",
            startButton: "Start",
            resolved: "Resolved",
            needHelp: "I Need Help",
            issue: "Issue",
            ok: "Ok",
            machinelistTitle: "Check your dishmachine, and make sure",
            do: "Do",
            doNot: "Don't",
            removeObstructionText: "Remove obstruction",
            internal: "Internal",
            external: "External",
            detail: "1. Check the water shutoff valve to ensure it's turned on",
            imageDetail: "2. Turn on the valve",
            top: "top",
            bottom: "bottom",
            drainIntake: "drain intake",
            scrapScreen: "scrap screens",
            floatSwitch: "float switch"
        },
        feedBack: {
            start: "Restart",
            resolveText: "Issue resolved!",
            qusetionText: "How likely would you be to recommend scanning the QR code to a coworker?",
            text1: "Extremely likely",
            text2: "Very likely",
            text3: "Somewhat likely",
            text4: "Not very likely",
            text5: "Not likely",
            optionalText: "Anything else you’d like to tell us? (optional)",
            submitButton: "Submit",
            trainingMessage: "Watch our training and maintenance videos to keep your machine running.",
            videoLink: "Watch Videos"
        },
        feedBackSummary: {
            start: "Restart",
            thankyouText: "Thank you for your feedback!",
            trainingMessage: "Watch our training and maintenance videos to keep your machine running.",
            videoLink: "Watch Videos",
            homeButton: "Return Home"
        },
        welcomePage: {
            welcomeMessage: "Welcome to your dishmachine digital support service!",
            accountLabel: "Please Enter Your Account Number",
            descriptionLabel: "Scan your account number on the sticker attached on dishmachine, or contact your Ecolab Associate",
            scanTitle: "Scan Account Number",
            cantfindLabel: "Can’t find account number?",
            clearButton: "Clear All",
            nextButton: "Next"
        },
        accountInfo: {
            header: "Your account number is here!",
            backLabel: "Back",
        },
        accountDetails: {
            header: "Is this information correct?",
            accountNumberLabel: "Account Number",
            customerAccountLabel: "Customer Name",
            addressLabel: "Address",
            cityLabel: "City",
            stateLabel: "State",
            zipLabel: "Zip",
            editButton: "Edit",
            nextButton: "Next",
            dishmachineLabel: "High temperature machines use heat to sanitize. Low temperature machines use chemical sanitizers.",
            cancelButton: "Cancel",
            verifyButton: "Verify Account",
            invalidLabel: "Invalid",
            backLabel: "Back",
            dishmachineModelType: "Change dishmachine model",
            notSure: "Not sure",
            noProblem: "No problem, you can continue!",
            done: "Done"
        },
        thankPage: {
            start: "Restart",
            message: "Thank you for choosing Ecolab!"
        },
        contactPage: {
            startLabel: "Restart",
            thankMessage: "Thank you for contacting us!",
            nextLabel: "What's Next",
            message: "Our team has received your request and will provide updates as service is completed. Service requests are processed 8am-4:30pm CT Monday - Friday.",
            backLabel: "Back",
        },
        poorResults: {
            header: "Check your dishmachine, and make sure",
            resolved: "Resolved",
            needHelp: "I Need Help",
            issue: "Issue",
            ok: "Ok",
            startLabel: "Restart",
            backLabel: "Back",
            do: "Do",
            doNot: "Don't",
            removeLimeText: "Remove limescale"
        },
        eult_poorResults: {
            limescale: "no limescale buildup",
            endCaps: "end caps in place",
            debris: "no debris in arms",
            chemical: "prime chemical pumps if the product is full and lines are empty",
            okBtn: "Ok",
            issueBtn: "Issue",
            resolved: "Resolved",
            needHelp: "I Need Help",
            header: "Check your dishmachine, and make sure",
            startLabel: "Restart",
            backLabel: "Back",
            do: "Do",
            doNot: "Don't",
            removeLimeText: "Remove limescale",
            videoTag: "Your browser does not support the video tag."
        },
        euht_poorResults: {
            limescale: "no limescale buildup",
            endCaps: "end caps in place",
            debris: "no debris in arms",
            chemical: "to prime chemistry if the product is full and lines are empty",
            okBtn: "Ok",
            issueBtn: "Issue",
            resolved: "Resolved",
            needHelp: "I Need Help",
            header: "Check your dishmachine, and make sure",
            startLabel: "Restart",
            backLabel: "Back",
            do: "Do",
            doNot: "Don't",
            removeLimeText: "Remove limescale",
            videoTag: "Your browser does not support the video tag."
        }
    },
    spanish: {
        landingPage: {
            welcomeMessage: "¡Bienvenido a su nuevo servicio de soporte digital!",
            helpMessage: "Cómo podemos ayudar",
            supportText: "Soporte para lavavajillas",
            productInfoText: "Información de Producto",
            trainingText: "Vídeos de entranamiento y mantenimiento",
            termsAndCondition: "Ver Términos de Uso",
            change: "Cambiar",
            dishmachineModelType: "Cambiar modelo de lavavajillas",
            downloadMessage: '¿Quiere gestionar su lavavajillas mientras viaja?',
            download: 'Descargar',
            deviceInfo: 'con tu',
                    },
        trainingPage: {
            header: "Formación para operadores para el ES-2000",
            maintenanceText: "Mantenimiento diario",
            troubleshooting: "Solución de problemas",
            prepareText: "Cómo preparar sus vajillas y utensilios para lavar",
            startOver: "Reanudar"
        },
        esrSupport: {
            header: "¿Es correcta esta información?",
            modelLabel: "Modelo de Máquina",
            accountLabel: "Nombre del cliente",
            stateLabel: "Estado",
            zipLabel: "Código Postal",
            updateButton: "No, necesita actualización",
            confirmButton: "Si, es correcta",
            startChat: "Iniciar chat",
            contactEcolab: "Llame a Ecolab",
            closeButton: "Cerca",
            startOver: "Reanudar",
            backLabel: "Atras",
            term1: "Al tocar “Llamar a Ecolab”, por la presente acepto recibir mensajes de texto.",
            term2: "mensajes de Ecolab relacionados con este problema",
            term3: "Al tocar “Iniciar chat”, por la presente acepto recibir mensajes de texto.",
            change: "Cambiar"

        },
        esrEdit: {
            header: "Necesitamos algunos detalles sobre su negocio para poder encontrar su cuenta.",
            typeLabel: "Modelo de Lavavajillas",
            modelLabel: "Modelo de Máquina",
            optionalLabel: "(opcional)",
            buisnessLabel: "Nombre del Negocio",
            addressLabel: "Dirección",
            cityLabel: "Ciudad",
            stateLabel: "Estado",
            zipLabel: "Código Postal",
            continueButton: "Continuar",
            addressError: "La dirección es necesaria.",
            cityError: "Se requiere ciudad."
        },
        esrSupportDetails: {
            header: "Si ninguno de estos pasos resuelve el problema, porfavor envie una solicitud de servicio y describa el problema",
            nameLabel: "Nombre de contacto en la ubicación",
            phoneLabel: "Número de teléfono en la ubicación",
            noteLabel: "Acepto recibir mensajes de texto de parte de Ecolab relacionado a este problema",
            detailLabel: "Detalles Adicionales (opcional)",
            directionLabel: "No incluya información confidencial como información de facturación, números de tarjetas de crédito, etc.",
            uploadButton: "Suba una Foto ",
            submitButton: "Enviar",
            summaryButton: "Summary",
            feildError: "Error enviando solicitud, porfavor verifique todos los campos",
            nameError: "Nombre es requerido",
            phoneError: "Número de teléfono es requerido"
        },
        esrSummary: {
            header: "Estado de la Solicitud",
            requsetLabel: "Solicitud",
            detailsLabel: "Ver Detalles",
            summaryText: "Problema enviado. Nuestro equipo recibió su solicitud y proveerá actualizaciones a medida que el servicio sea completado. Puede referirse a ésta página via el enlace que fue enviado al número teléfonico ingreasado",
            infoText: "Las solicitudes de servicio se procesarán entre las 8 a. m. y las 4:30 p. m. CT de lunes a viernes. Si necesita ayuda inmediata, llame",
            closeButton: "Solicitud Cerrada",
            commentButton: "Agregue Comentario"
        },
        troubleShooting: {
            header: "¿Qué está sucediendo?",
            startLabel: "Reanudar",
            backLabel: "Atras",
            trouble: "Solución de problemas",
            label: "¡Vamos a arreglar tu máquina!",
            estimation: "Tiempo estimado: 5 - 10 min",
            desc: "Siga estos pasos para solucionar su problema. Si el problema no se resuelve, lo ayudaremos a enviar un ticket de soporte.",
            poorResults: 'Malos resultados',
            machineIssue: 'Problema con la máquina',
            next: 'Próxima',
            start: 'Comenzar'
        },
        steps: {
            header: "Seleccione un problema",
            startLabel: "Reanudar",
            backLabel: "Atras",
            helpButton: "Solicite Ayuda",
            fixLabel: "¡Arreglemos tu máquina!",
            infoText: "Le mostraremos algunos pasos rápidos de solución de problemas que puede probar.",
            stepMessage: "Si no funcionan, puede enviar una solicitud de servicio después de ver los pasos de solución de problemas.",
            startButton: "Comenzar",
            resolved: 'Resuelto',
            needHelp: 'Necesito ayuda',
            issue: 'Problema',
            ok: 'De acuerdo',
            machinelistTitle: "Verifique su máquina de platos y asegúrese de",
            do: "Hacer",
            doNot: "No",
            removeObstructionText: "Quitar obstrucción",
            internal: "Interna",
            external: "Externa",
            detail: "1. Verifique la válvula de cierre de agua para asegurarse de que esté abierta.",
            imageDetail: "2. Enciende la válvula",
            top: "arriba",
            bottom: "abajo",
            drainIntake: "toma de drenaje",
            scrapScreen: "pantallas de chatarra",
            floatSwitch: "interruptor de flotador"
        },
        feedBack: {
            start: "Reanudar",
            resolveText: "¡Problema Resuelto!",
            qusetionText: "¿Qué probabilidad hay de que recomiende escanear el código QR a un compañero de trabajo?",
            text1: "Extremadamente probable",
            text2: "Muy probable",
            text3: "Algo probable",
            text4: "No muy probable",
            text5: "No es probable",
            optionalText: "¿Quisiera contarnos algo más? (opcional)",
            submitButton: "Enviar",
            trainingMessage: "Mire nuestros videos de capacitación y mantenimiento para mantener su máquina en funcionamiento.",
            videoLink: "Ver videos"
        },
        feedBackSummary: {
            start: "Reanudar",
            thankyouText: "¡Gracias por tus comentarios!",
            trainingMessage: "Mire nuestros videos de capacitación y mantenimiento para mantener su máquina en funcionamiento.",
            videoLink: "Ver videos",
            homeButton: "Volver al Inicio"
        },
        welcomePage: {
            welcomeMessage: "¡Bienvenido a su servicio de soporte digital para lavavajillas!",
            accountLabel: "Por favor, introduzca su número de cuenta",
            descriptionLabel: "Escanee su número de cuenta en la pegatina adjunta en la máquina lavavajillas o comuníquese con su asociado de Ecolab",
            scanTitle: "Escanear número de cuenta",
            cantfindLabel: "¿No encuentras el número de cuenta?",
            clearButton: "Borrar todo",
            nextButton: "Próximo"
        },
        accountInfo: {
            header: "¡Tu número de cuenta está aquí!",
            backLabel: "Atras",
        },
        accountDetails: {
            header: "¿Es correcta esta información?",
            accountNumberLabel: "número de cuenta",
            customerAccountLabel: "Nombre del cliente",
            addressLabel: "Dirección",
            cityLabel: "Ciudad",
            stateLabel: "Estado",
            zipLabel: "Código Postal",
            editButton: "Editar",
            nextButton: "Próximo",
            dishmachineLabel: "Las máquinas de alta temperatura utilizan calor para desinfectar. Las máquinas de baja temperatura utilizan desinfectantes químicos.",
            cancelButton: "Cancelar",
            verifyButton: "Verificar cuenta",
            invalidLabel: "Inválido",
            backLabel: "Atras",
            dishmachineModelType: " Cambiar modelo de lavavajillas",
            notSure: "No estoy segura",
            noProblem: "¡No hay problema, puedes continuar!",
            done: "Hecho"
        },
        thankPage: {
            start: "Reanudar",
            message: "¡Gracias por elegir Ecolab!"
        },
        contactPage: {
            startLabel: "Reanudar",
            thankMessage: "Gracias por contactar con nosotras!",
            nextLabel: "¿Qué sigue?",
            message: "Nuestro equipo ha recibido su solicitud y proporcionará actualizaciones a medida que se complete el servicio. Las solicitudes de servicio se procesan de 8 a. m. a 4:30 p. m. CT, de lunes a viernes.",
            backLabel: "Atras",
        },
        poorResults: {
            header: 'Verifique su máquina de platos y asegúrese de',
            resolved: 'Resuelto',
            needHelp: 'Necesito ayuda',
            issue: 'Problema',
            ok: 'De acuerdo',
            startLabel: "Reanudar",
            backLabel: "Atras",
            do: "Hacer",
            doNot: "No",
            removeLimeText: "Quitar la cal"
        },
        eult_poorResults: {
            limescale: "sin acumulación de sarro",
            endCaps: "tapas finales en su lugar",
            debris: "sin desechos en los brazos",
            chemical: "Cebe las bombas químicas si el producto está lleno y las líneas están vacías",
            okBtn: "De acuerdo",
            issueBtn: "Problema",
            resolved: 'Resuelto',
            needHelp: 'Necesito ayuda',
            header: 'Verifique su máquina de platos y asegúrese de',
            startLabel: "Reanudar",
            backLabel: "Atras",
            do: "Hacer",
            doNot: "No",
            removeLimeText: "Quitar la cal",
            videoTag: "Su navegador no soporta la etiqueta de vídeo."
        },
        euht_poorResults: {
            limescale: "sin acumulación de sarro",
            endCaps: "tapas finales en su lugar",
            debris: "sin desechos en los brazos",
            chemical: "Para preparar la química si el producto está lleno y las líneas están vacías",
            okBtn: "De acuerdo",
            issueBtn: "Problema",
            resolved: 'Resuelto',
            needHelp: 'Necesito ayuda',
            header: 'Verifique su máquina de platos y asegúrese de',
            startLabel: "Reanudar",
            backLabel: "Atras",
            do: "Hacer",
            doNot: "No",
            removeLimeText: "Quitar la cal",
            videoTag: "Su navegador no soporta la etiqueta de vídeo."
        }
    },
    french: {
        landingPage: {
          welcomeMessage: "Bienvenue dans votre nouveau service d'assistance numérique !",
          helpMessage: "Comment pouvons-nous aider",
          supportText: "Assistance pour lave-vaisselle",
          productInfoText: "Informations sur le produit",
          trainingText: "Vidéos de formation et de maintenance",
          accountInfo: "Informations sur le compte",
          termsAndCondition: "Termes et Conditions",
          change: "Changer",
          dishmachineModelType: "Changer le modèle de lave-vaisselle",
          downloadMessage: "Voulez-vous gérer votre lave-vaisselle en déplacement ?",
          download: "Télécharger",
          deviceInfo: "avec votre"
        },
        trainingPage: {
          header: "Formation pour opérateurs pour l'ES-2000",
          maintenanceText: "Entretien quotidien",
          troubleshooting: "Dépannage",
          prepareText: "Comment préparer votre vaisselle pour le lavage",
          startOver: "Redémarrer"
        },
        esrSupport: {
          header: "Ces informations sont-elles correctes ?",
          modelLabel: "Modèle de lave-vaisselle",
          accountLabel: "Nom du client",
          stateLabel: "État",
          zipLabel: "Code Postal",
          updateButton: "Non, besoin de mettre à jour",
          confirmButton: "Oui, c'est correct",
          startChat: "Démarrer le chat",
          contactEcolab: "Appeler Ecolab",
          closeButton: "Fermer",
          backLabel: "Retour",
          startOver: "Redémarrer",
          term1: "en appuyant sur “Appeler Ecolab” j'accepte de recevoir des messages texte",
          term2: "messages d'Ecolab liés à ce problème",
          term3: "en appuyant sur “Démarrer le chat” j'accepte de recevoir des messages texte",
          change: "Changer"
        },
        esrEdit: {
          header: "Nous avons besoin de quelques détails sur votre entreprise pour trouver votre compte",
          typeLabel: "Type de lave-vaisselle",
          modelLabel: "Modèle de lave-vaisselle",
          optionalLabel: "(optionnel)",
          buisnessLabel: "Nom de l'entreprise",
          addressLabel: "Adresse",
          cityLabel: "Ville",
          stateLabel: "État",
          zipLabel: "Code Postal",
          continueButton: "Continuer",
          addressError: "L'adresse est requise.",
          cityError: "La ville est requise."
        },
        esrSupportDetails: {
          header: "Si aucune de ces étapes ne résout le problème, veuillez soumettre une demande de service et décrire le problème.",
          nameLabel: "Nom du contact sur site",
          phoneLabel: "Numéro de téléphone sur site",
          noteLabel: "J'accepte de recevoir des textos d'Ecolab liés à ce problème",
          detailLabel: "Détails supplémentaires (optionnel)",
          directionLabel: "Ne pas inclure d'informations sensibles comme des informations de facturation, numéros de carte de crédit, etc.",
          uploadButton: "Télécharger une photo",
          submitButton: "Soumettre",
          summaryButton: "Résumé",
          feildError: "Erreur lors de l'envoi de la demande, veuillez vérifier les champs.",
          nameError: "Le nom est requis.",
          phoneError: "Le numéro de téléphone est requis."
        },
        esrSummary: {
          header: "Statut de la demande",
          requsetLabel: "Demande",
          detailsLabel: "Voir les détails",
          summaryText: "Problème soumis. Notre équipe a reçu votre demande et fournira des mises à jour ici lorsque le service sera terminé. Vous pouvez consulter cette page via le lien qui a été envoyé par SMS au numéro fourni.",
          infoText: "Les demandes de service seront traitées entre 8h et 16h30 CT du lundi au vendredi. Si vous avez besoin d'une assistance immédiate, appelez",
          closeButton: "Fermer la demande",
          commentButton: "Ajouter un commentaire"
        },
        troubleShooting: {
          header: "Que se passe-t-il ?",
          startLabel: "Redémarrer",
          backLabel: "Retour",
          trouble: "Dépannage",
          label: "Réparons votre machine !",
          estimation: "Temps estimé : 5 - 10 min",
          desc: "Suivez ces étapes pour dépanner votre problème. Si le problème n'est pas résolu, nous vous aiderons à soumettre une demande d'assistance.",
          poorResults: "Mauvais résultats",
          machineIssue: "Problème de machine",
          next: "Suivant",
          start: "Commencer"
        },
        steps: {
          header: "Sélectionnez un problème",
          startLabel: "Redémarrer",
          backLabel: "Retour",
          helpButton: "Demander de l'aide",
          fixLabel: "Réparons votre machine !",
          infoText: "Nous vous montrerons quelques étapes rapides de dépannage que vous pouvez essayer.",
          stepMessage: "Si cela ne fonctionne pas, vous pouvez soumettre une demande de service après avoir vu les étapes de dépannage.",
          startButton: "Commencer",
          resolved: "Résolu",
          needHelp: "J'ai besoin d'aide",
          issue: "Problème",
          ok: "D'accord",
          machinelistTitle: "Vérifiez votre lave-vaisselle et assurez-vous que",
          do: "Faites",
          doNot: "Ne faites pas",
          removeObstructionText: "Retirer l'obstruction",
          internal: "Interne",
          external: "Externe",
          detail: "1. Vérifiez la vanne d'arrêt d'eau pour vous assurer qu'elle est ouverte",
          imageDetail: "2. Ouvrez la vanne",
          top: "haut",
          bottom: "bas",
          drainIntake: "entrée de vidange",
          scrapScreen: "écrans de débris",
          floatSwitch: "Interrupteur à flotteur"
        },
        feedBack: {
          start: "Redémarrer",
          resolveText: "Problème résolu !",
          qusetionText: "Quelle est la probabilité que vous recommandiez de scanner le code QR à un collègue ?",
          text1: "Très probable",
          text2: "Très probable",
          text3: "Assez probable",
          text4: "Pas très probable",
          text5: "Pas probable",
          optionalText: "Souhaitez-vous nous dire autre chose ? (optionnel)",
          submitButton: "Soumettre",
          trainingMessage: "Regardez nos vidéos de formation et de maintenance pour que votre machine fonctionne.",
          videoLink: "Voir les vidéos"
        },
        feedBackSummary: {
          start: "Redémarrer",
          thankyouText: "Merci pour votre retour !",
          trainingMessage: "Regardez nos vidéos de formation et de maintenance pour que votre machine fonctionne.",
          videoLink: "Voir les vidéos",
          homeButton: "Retour à l'accueil"
        },
        welcomePage: {
          welcomeMessage: "Bienvenue dans votre service d'assistance numérique pour lave-vaisselle !",
          accountLabel: "Veuillez saisir votre numéro de compte",
          descriptionLabel: "Scannez votre numéro de compte sur l'autocollant attaché au lave-vaisselle ou contactez votre associé Ecolab",
          scanTitle: "Scanner le numéro de compte",
          cantfindLabel: "Impossible de trouver le numéro de compte ?",
          clearButton: "Tout effacer",
          nextButton: "Suivant"
        },
        accountInfo: {
          header: "Votre numéro de compte est ici !",
          backLabel: "Retour"
        },
        accountDetails: {
          header: "Ces informations sont-elles correctes ?",
          accountNumberLabel: "Numéro de compte",
          customerAccountLabel: "Nom du client",
          addressLabel: "Adresse",
          cityLabel: "Ville",
          stateLabel: "État",
          zipLabel: "Code Postal",
          editButton: "Modifier",
          nextButton: "Suivant",
          dishmachineLabel: "Les machines à haute température utilisent la chaleur pour désinfecter. Les machines à basse température utilisent des désinfectants chimiques.",
          cancelButton: "Annuler",
          verifyButton: "Vérifier le compte",
          invalidLabel: "Invalide",
          backLabel: "Retour",
          dishmachineModelType: "Changer le modèle de lave-vaisselle",
          notSure: "Pas sûr",
          noProblem: "Pas de problème, vous pouvez continuer !",
          done: "Terminé"
        },
        thankPage: {
          start: "Redémarrer",
          message: "Merci d'avoir choisi Ecolab !"
        },
        contactPage: {
          startLabel: "Redémarrer",
          thankMessage: "Merci de nous avoir contactés !",
          nextLabel: "Et après ?",
          message: "Notre équipe a reçu votre demande et vous donnera des mises à jour lorsque le service sera terminé. Les demandes de service sont traitées de 8h à 16h30 CT du lundi au vendredi.",
          backLabel: "Retour"
        },
        poorResults: {
          header: "Vérifiez votre lave-vaisselle et assurez-vous que",
          resolved: "Résolu",
          needHelp: "J'ai besoin d'aide",
          issue: "Problème",
          ok: "D'accord",
          startLabel: "Redémarrer",
          backLabel: "Retour",
          do: "Faites",
          doNot: "Ne faites pas",
          removeLimeText: "Retirer le calcaire"
        },
        eult_poorResults: {
          limescale: "aucune accumulation de calcaire",
          endCaps: "embouts en place",
          debris: "aucun débris dans les bras",
          chemical: "Primar les pompes chimiques si le produit est plein et les lignes sont vides",
          okBtn: "D'accord",
          issueBtn: "Problème",
          resolved: "Résolu",
          needHelp: "J'ai besoin d'aide",
          header: "Vérifiez votre lave-vaisselle et assurez-vous que",
          startLabel: "Redémarrer",
          backLabel: "Retour",
          do: "Faites",
          doNot: "Ne faites pas",
          removeLimeText: "Retirer le calcaire",
          videoTag: "Votre navigateur ne prend pas en charge la balise vidéo."
        },
        euht_poorResults: {
          limescale: "aucune accumulation de calcaire",
          endCaps: "embouts en place",
          debris: "aucun débris dans les bras",
          chemical: "Pour amorcer la chimie si le produit est plein et que les lignes sont vides",
          okBtn: "D'accord",
          issueBtn: "Problème",
          resolved: "Résolu",
          needHelp: "J'ai besoin d'aide",
          header: "Vérifiez votre lave-vaisselle et assurez-vous que",
          startLabel: "Redémarrer",
          backLabel: "Retour",
          do: "Faites",
          doNot: "Ne faites pas",
          removeLimeText: "Retirer le calcaire",
          videoTag: "Votre navigateur ne prend pas en charge la balise vidéo."
        }
    }
}  